<div class="dialog-header-container">
  <mat-toolbar class="toolbar-container">
    <div class="md-toolbar-tools">
      <h1 mat-dialog-title>{{ title }}</h1>
      <span flex></span>
      <div class="posicionar-direita">
        <button (click)="onRestore()" class="botao-header" [hidden]="!maximizado" matTooltip="Minimizar">
          <mat-icon>fullscreen_exit</mat-icon>
        </button>
        <button (click)="onMaximize()" class="botao-header" [hidden]="maximizado" matTooltip="Expandir">
          <mat-icon>fullscreen</mat-icon>
        </button>
        <button (click)="onClose()" class="botao-header" matTooltip="Fechar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-toolbar>
  
  <div class="dialog-content-wrapper" style="display: flex; flex-direction: column;">
    <div class="dialog-actions">
      <div class="container-fluid p-0">
        <div class="row no-gutters actions-flex-row">
          <div class="col-md-6 col-sm-12">
            <div class="button-container">
              <ng-container *ngFor="let button of buttons">
                <button mat-raised-button *ngIf="button.type === 'simple'" 
                        [color]="button.cor || ''"
                        [matTooltip]="button.tooltip || button.texto"
                        [disabled]="button.disabled ? !button.disabled(element) : false"
                        (click)="button.aoClicar && button.aoClicar()">
                  <mat-icon *ngIf="button.icone">{{ button.icone }}</mat-icon>
                  <span>{{ button.texto }}</span>
                </button>
                
                <button mat-raised-button *ngIf="button.type === 'dropdown'" 
                        [matMenuTriggerFor]="menu"
                        [disabled]="button.disabled ? !button.disabled(element) : (button.show ? !button.show(element) : false)"
                        [matTooltip]="button.tooltip || button.texto">
                  <mat-icon *ngIf="button.icone">{{ button.icone }}</mat-icon>
                  <span *ngIf="button.texto">{{ button.texto }}</span>
                </button>
                <mat-menu #menu="matMenu">
                  <ng-container *ngIf="button.opcoesMenu">
                    <ng-container *ngFor="let opcao of button.opcoesMenu">
                      <button *ngIf="opcao.show ? opcao.show(element) : true" 
                              mat-menu-item 
                              [disabled]="opcao.disabled ? !opcao.disabled(element) : false"
                              (click)="opcao.method(element)">
                        {{ opcao.name }}
                      </button>
                    </ng-container>
                  </ng-container>
                </mat-menu>
              </ng-container>
            </div>
          </div>
          <div class="col-md-6 col-sm-12" *ngIf="templateAcoes">
            <div class="template-acoes">
              <ng-container *ngTemplateOutlet="templateAcoes"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="tabs-wrapper" style="width: 100%;">
      <div *ngIf="showTabs" class="tab-container" style="background-color: #f5f5f5; padding: 0; margin: 0 -24px; width: calc(100% + 48px);">
        <div class="tabs" style="display: flex; margin: 0;">
          <button *ngFor="let tab of tabs" 
                 class="tab-button" 
                 [class.active]="selectedTab === tab.id" 
                 (click)="onTabChange(tab.id)" 
                 style="flex: 1; padding: 12px 15px; border: none; background: none; cursor: pointer; font-size: 15px; font-weight: 500; border-bottom: 3px solid transparent;" 
                 [style.border-bottom-color]="selectedTab === tab.id ? '#0c4d51' : 'transparent'">
            {{tab.label}}
          </button>
        </div>
      </div>
  
      <div *ngIf="showErrorBanner" class="error-banner" style="background-color: #db5b5b; color: white; padding: 10px; border-radius: 0; margin: 0 -24px; width: calc(100% + 48px);">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="font-weight: bold; font-size: 16px;">
            <span style="display: inline-block; vertical-align: middle; margin-right: 8px;">⚠️</span> {{errorTitle}}
          </div>
          <button type="button" (click)="onCloseErrorBanner()" style="background: none; border: none; font-size: 16px; cursor: pointer; color: white; font-weight: bold;">
            ×
          </button>
        </div>
        <div style="margin-top: 5px; margin-left: 25px;">
          <div *ngFor="let message of errorMessages" style="margin-bottom: 5px;">
            * {{message}}
          </div>
          <ng-content select="[error-messages]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="dialog-content">
  <ng-content></ng-content>
</div>
